import { getFormatDate } from "~/libs/getFormatDate";
import { StatusOptions } from "~/shared/lib/statuses";

import { Position } from "./types";

export const transformTableData = (dataItems: Position[]) => {
  if (!dataItems || !Array.isArray(dataItems)) {
    return [];
  }

  return dataItems.map((item: Position) => {
    const {
      InstanceId,
      code,
      name,
      Direction,
      status,
      createdAt,
      updatedAt,
      RequiredEmail,
    } = item;

    return {
      ...item,
      id: InstanceId,
      positionCode: code,
      titlePosition: name,
      belongingDirectionID: Direction?.name,
      status: StatusOptions[status],
      createdAt: getFormatDate(createdAt),
      updatedAt: getFormatDate(updatedAt),
      RequiredEmail: RequiredEmail ? "Да" : "Нет",
    };
  });
};
